// import React from 'react';

// function ViewAccountDetails(props) {
//   // Extract details from props
//   const name =
//     props.viewaccountdetails?.ACCOUNTENQUIRYDETAILS_RESPONSE?.BODY?.PAYLOAD?.ACCOUNT_NAME;
//   const branchcode =
//     props.viewaccountdetails?.ACCOUNTENQUIRYDETAILS_RESPONSE?.BODY?.PAYLOAD?.ACCOUNT_BRANCH;
//   const branchname =
//     props.viewaccountdetails?.ACCOUNTENQUIRYDETAILS_RESPONSE?.BODY?.PAYLOAD?.BRANCH_NAME;
//   const ifscode = props.viewaccountdetails?.IFSCcode;
//   const cifnum=props.viewaccountdetails.ACCOUNTENQUIRYDETAILS_RESPONSE.BODY.PAYLOAD.CIF_NUMBER;
//   const accountnum=props.viewaccountdetails.ACCOUNTENQUIRYDETAILS_RESPONSE.BODY.PAYLOAD.ACCOUNT_NUMBER;
  
//   console.log(
//     "Account Details:",
//     name,
//     branchcode,
//     branchname,
//     ifscode,
//     accountnum,
//     props
//   );

//   return (
//     <div
//       className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70"
//       style={{
//         border: '8px solid rgba(244, 176, 53, 0.8)',
//         backgroundColor: 'rgba(245, 243, 243, 1)',
//         marginLeft: '10px',
//       }}
//     >
//       <h5 style={{fontSize:"14px",fontWeight:"600",textAlign:"center"}}>Account Details</h5>
//       <h5>{`Account Number:${accountnum ||'NA'}`}</h5>
//       <h5>{`Account Name: ${name || 'N/A'}`}</h5>
//       <h5>{`CIF Number :${cifnum||"NA"}`}</h5>
//       <h5>{`Branch Name :${branchname}`}</h5>
//       <h5>{`IFSC Code: ${ifscode || 'N/A'}`}</h5>
//       <h5>{`Branch Code: ${branchcode || 'N/A'}`}</h5>
   
//     </div>
//   );
// }

// export default ViewAccountDetails;
import React from 'react';
function convertDateFormat(dateString) {
  // Extract day, month, and year from the input string
  const day = dateString.slice(0, 2);
  const month = dateString.slice(2, 4);
  const year = dateString.slice(4);

  // Return the date in "dd-mm-yyyy" format
  return `${day}-${month}-${year}`;
}

function ViewAccountDetails(props) {
  
  // Extract details from props
  console.log("Account Details:", props)
  // props.viewaccountdetails.AccountEnquiryDetails_Response.Body.Payload.Account_Number
//   const name =
//     props?.ACCOUNTENQUIRYDETAILS_RESPONSE?.BODY?.PAYLOAD?.ACCOUNT_NAME;
//     const type = props?.ACCOUNTENQUIRYDETAILS_RESPONSE?.BODY.PAYLOAD?.
//     ACCOUNT_TYPE
//   const status = props?.ACCOUNTENQUIRYDETAILS_RESPONSE?.BODY?.PAYLOAD?.AC_STATUS    
//   const accountOpeningDate = convertDateFormat(props?.ACCOUNTENQUIRYDETAILS_RESPONSE?.BODY?.PAYLOAD?.ACC_OPENING_DATE)
//   const nomineeStatus = props?.ACCOUNTENQUIRYDETAILS_RESPONSE?.BODY?.PAYLOAD?.NOMINEE_AVILABLE
//   const availableBalance = props?.ACCOUNTENQUIRYDETAILS_RESPONSE?.BODY?.PAYLOAD?.AVAILABLE_BAL
//  const accountnum=props.ACCOUNTENQUIRYDETAILS_RESPONSE.BODY.PAYLOAD.ACCOUNT_NUMBER;

//   const branchcode =
//     props?.ACCOUNTENQUIRYDETAILS_RESPONSE?.BODY?.PAYLOAD?.ACCOUNT_BRANCH;
//   const branchname =
//     props?.ACCOUNTENQUIRYDETAILS_RESPONSE?.BODY?.PAYLOAD?.BRANCH_NAME;
//   const ifscode = props?.IFSCcode;
//   const cifnum=props.ACCOUNTENQUIRYDETAILS_RESPONSE.BODY.PAYLOAD.CIF_NUMBER
const ifscode = props?.viewaccountdetails.IFSCcode;
  const ACCOUNT_HOLDER_NAME =
  props?.viewaccountdetails.AccountEnquiryDetails_Response.Body.Payload.Account_Name;
  const ACCOUNT_TYPE =  props?.viewaccountdetails.AccountEnquiryDetails_Response?.Body?.Payload?.Account_Type
const AC_STATUS  = props?.viewaccountdetails.AccountEnquiryDetails_Response?.Body?.Payload?.AC_Status    
const ACC_OPENING_DATE = convertDateFormat(props?.viewaccountdetails.AccountEnquiryDetails_Response.Body?.Payload?.ACc_Opening_Date)
const NOMINEE_AVILABLE = props?.viewaccountdetails.AccountEnquiryDetails_Response?.Body?.Payload?.Nominee_Avilable
const AVAILABLE_BAL = (props?.viewaccountdetails.AccountEnquiryDetails_Response?.Body?.Payload?.Available_Bal).replace(/\+$/, '')
const ACCOUNT_NUMBER=props?.viewaccountdetails.AccountEnquiryDetails_Response.Body?.Payload?.Account_Number;

const ACCOUNT_BRANCH =
props?.viewaccountdetails.AccountEnquiryDetails_Response.Body?.Payload?.Account_Branch;
const BRANCH_NAME=
props?.viewaccountdetails.AccountEnquiryDetails_Response.Body?.Payload?.Branch_Name;

const CIF_NUMBER= props?.viewaccountdetails.AccountEnquiryDetails_Response.Body?.Payload?.CIF_Number
//   console.log(
//     "Account Details:",
//     name,
//     branchcode,
//     branchname,
//     ifscode,
//     props
//   );

  return (
    <div
      className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70"
      style={{
        border: '8px solid rgba(244, 176, 53, 0.8)',
        backgroundColor: 'rgba(245, 243, 243, 1)',
        marginLeft: '10px',
      }}
    >
      <h5 style={{fontSize:"14px",fontWeight:"600",textAlign:"center"}}>Account Details</h5>
      <h5>{`Account Name: ${ACCOUNT_HOLDER_NAME || 'N/A'}`}</h5>
      <h5>{`Account Number:${ACCOUNT_NUMBER ||'NA'}`}</h5>
      
      <h5>{`Savings Account: ${ACCOUNT_TYPE || 'N/A'}`}</h5>
      <h5>{`Account Status :${AC_STATUS||"NA"}`}</h5>

      <h5>{`CIF Number :${CIF_NUMBER||"NA"}`}</h5>
      <h5>{`Nominee Status :${NOMINEE_AVILABLE||"NA"}`}</h5>
      <h5>{`Account Opening Date :${ACC_OPENING_DATE||"NA"}`}</h5>

      <h5>{`Branch Name :${BRANCH_NAME}`}</h5>
      {/* <h5>{`IFSC Code: ${I || 'N/A'}`}</h5> */}
      <h5>{`Branch Code: ${ACCOUNT_BRANCH || 'N/A'}`}</h5>
      <h5>{`Available Balance: ₹${AVAILABLE_BAL || 'N/A'}`}</h5>
      <h5>{`IFSC Code:${ifscode}`}</h5>
      {/* <p>hello</p> */}


    </div>
  );
}

export default ViewAccountDetails;